import { render, staticRenderFns } from "./AddFood.vue?vue&type=template&id=c6dcb490&scoped=true&"
var script = {}
import style0 from "./AddFood.vue?vue&type=style&index=0&id=c6dcb490&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6dcb490",
  null
  
)

export default component.exports